import { Component, Inject } from '@angular/core';
import { ComplaintAppointment, Complaint, DocumentAttachment } from '@icc/b2b/shared';
import { DIALOG_DATA, DialogRef } from '@icc/ui';

@Component({
  selector: 'icc-complaint-appointment-dialog',
  templateUrl: './complaint-appointment-dialog.component.html',
  styleUrls: ['./complaint-appointment-dialog.component.scss']
})
export class ComplaintAppointmentDialogComponent {
  isValidDate = false;

  constructor(
    private dialogRef: DialogRef,
    @Inject(DIALOG_DATA)
    public data: {
      appointment: ComplaintAppointment;
      complaint: Complaint;
      attachments: DocumentAttachment[];
      editMode: boolean;
    },
  ) {}

  validateDate(event: boolean) {
    this.isValidDate = event;
  }

  async save() {
    this.dialogRef.close({
      appointment: this.data.appointment,
      attachments: this.data.attachments,
    });
  }

  close() {
    this.dialogRef.close();
  }
}
